import { createFileRoute } from "@tanstack/react-router";
import { AgentConnectCatalog } from "@/components/agents/agent-connect-pages";
import { OwnerWorkspaceGate } from "@/components/owner-workspace-gate";

export const Route = createFileRoute("/$owner/agents/connect/")({
	component: AgentConnectCatalogPage,
});

function AgentConnectCatalogPage() {
	const { owner } = Route.useParams();
	return (
		<OwnerWorkspaceGate owner={owner}>
			{({ ownerSlug }) => <AgentConnectCatalog owner={ownerSlug} />}
		</OwnerWorkspaceGate>
	);
}
